import Vue from 'vue'

export default {
  listarPublicacao: () => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
          listarPublicacao{
            id
            titulo
            texto
            data
            ativa
            publicado
            cor_fundo
            ordem
            grupo{
              id
              descricao
              exibir
              ordem
            }
            autor{
              id
              nome
            }
            editorial{
              id
              titulo
              descricao
              data
              ativa
              publicado
            }
          }
        }`
      }
    })
  },
  listarPublicacaoByTitulo: (titulo) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
          listarPublicacao(titulo: ${titulo}){
            id
            titulo
            texto
            data
            ativa
            publicado
            cor_fundo
            ordem
            grupo{
              id
              descricao
              exibir
              ordem
            }
            autor{
              id
              nome
            }
            editorial{
              id
              titulo
              descricao
              data
              ativa
              publicado
            }
          }
        }`
      }
    })
  },
  listarPublicacaoByData: (data) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
          listarPublicacao(data: ${data}){
            id
            titulo
            texto
            data
            ativa
            publicado
            cor_fundo
            ordem
            grupo{
              id
              descricao
              exibir
              ordem
            }
            autor{
              id
              nome
            }
            editorial{
              id
              titulo
              descricao
              data
              ativa
              publicado
            }
          }
        }`
      }
    })
  },
  listarPublicacaoByGrupo: (grupo_id) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
          listarPublicacao(grupo_id: ${grupo_id}){
            id
            titulo
            texto
            data
            ativa
            publicado
            cor_fundo
            ordem
            grupo{
              id
              descricao
              exibir
              ordem
            }
            autor{
              id
              nome
            }
            editorial{
              id
              titulo
              descricao
              data
              ativa
              publicado
            }
          }
        }`
      }
    })
  },
  listarPublicacaoByEditorial: (editorial_id) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
          listarPublicacaoByEditorial(editorial_id: ${editorial_id}){
            id
            titulo
            texto
            data
            ativa
            publicado
            cor_fundo
            ordem
            grupo{
              id
              descricao
              exibir
              ordem
            }
            autor{
              id
              nome
            }
            editorial{
              id
              titulo
              descricao
              data
              ativa
              publicado
            }
            midia{
              id
              type
              video_url
              link_url
              cor_fundo
              tipo_midia{
                id
                descricao
                largura
                altura
                formato
              }
              imagem
            }
          }
        }`
      }
    })
  },
  listarPublicacaoPrincipalByEditorial: (editorial_id) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
          listarPublicacaoPrincipalByEditorial(editorial_id: ${editorial_id}){
            id
            titulo
            texto
            data
            ativa
            publicado
            cor_fundo
            ordem
            grupo{
              id
              descricao
              exibir
              ordem
            }
            autor{
              id
              nome
            }
            editorial{
              id
              titulo
              descricao
              data
              ativa
              publicado
            }
            midia{
              id
              type
              video_url
              link_url
              cor_fundo
              tipo_midia{
                id
                descricao
                largura
                altura
                formato
              }
              imagem
            }
          }
        }`
      }
    })
  },
  listarPublicacaoPublicada: () => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
          listarPublicacao(publicado: S){
            id
            titulo
            texto
            data
            ativa
            publicado
            cor_fundo
            ordem
            grupo{
              id
              descricao
              exibir
              ordem
            }
            autor{
              id
              nome
            }
            editorial{
              id
              titulo
              descricao
              data
              ativa
              publicado
            }
          }
        }`
      }
    })
  },
  listarPublicacaoNaoPublicada: () => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
          listarPublicacao(publicado: N){
            id
            titulo
            texto
            data
            ativa
            publicado
            cor_fundo
            ordem
            grupo{
              id
              descricao
              exibir
              ordem
            }
            autor{
              id
              nome
            }
            editorial{
              id
              titulo
              descricao
              data
              ativa
              publicado
            }
            midia{
              id
              type
              video_url
              link_url
              cor_fundo
              tipo_midia{
                id
                descricao
                largura
                altura
                formato
              }
              imagem
            }
          }
        }`
      }
    })
  },
  criarPublicacao: (publicacaoInput) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `mutation{
          criarPublicacao(data:{
            titulo: "${(Vue.prototype.$utils.isNotNull(publicacaoInput.titulo)) ? publicacaoInput.titulo : ''}"
            texto: "${(Vue.prototype.$utils.isNotNull(publicacaoInput.texto)) ? publicacaoInput.texto : ''}"
            data: "${publicacaoInput.data}"
            ativa: ${(Vue.prototype.$utils.isNotNull(publicacaoInput.ativa)) ? publicacaoInput.ativa : 'S'}
            publicado: S
            cor_fundo: "${(Vue.prototype.$utils.isNotNull(publicacaoInput.cor_fundo)) ? publicacaoInput.cor_fundo : ''}"
            ordem: ${publicacaoInput.ordem}
            grupo_id: ${publicacaoInput.grupo_id.id}
            autor_id: ${(publicacaoInput.autor_id) ? publicacaoInput.autor_id : null}
            editorial_id: ${publicacaoInput.editorial_id}
            imagem: ${JSON.stringify(publicacaoInput.imagem)}
          }){
            id
          }
        }`
      }
    })
  },
  atualizarPublicacao: (publicacaoInput) => {
    console.log(publicacaoInput.imagem)
    console.log(JSON.stringify(publicacaoInput.imagem))
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `mutation{
          atualizarPublicacao(id: ${publicacaoInput.id}, data:{
            titulo: "${(Vue.prototype.$utils.isNotNull(publicacaoInput.titulo)) ? publicacaoInput.titulo : ''}"
            texto: "${(Vue.prototype.$utils.isNotNull(publicacaoInput.texto)) ? publicacaoInput.texto : ''}"
            data: "${publicacaoInput.data}"
            ativa: ${(Vue.prototype.$utils.isNotNull(publicacaoInput.ativa)) ? publicacaoInput.ativa : 'S'}
            publicado: S
            cor_fundo: "${(Vue.prototype.$utils.isNotNull(publicacaoInput.cor_fundo)) ? publicacaoInput.cor_fundo : ''}"
            ordem: ${publicacaoInput.ordem}
            grupo_id: ${publicacaoInput.grupo_id.id}
            autor_id: ${(publicacaoInput.autor_id) ? publicacaoInput.autor_id : null}
            editorial_id: ${publicacaoInput.editorial_id}
            imagem: ${JSON.stringify(publicacaoInput.imagem)}
          }){
            id
          }
        }`
      }
    })
  },
  deletarPublicacao: (publicacaoId) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `mutation{
          deletarPublicacao(id: ${publicacaoId})
        }`
      }
    })
  },

  listarAnuncio: () => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
          listarAnuncio{
            id
            titulo
            cor_fundo
            midia{
              id
              type
              video_url
              link_url
              cor_fundo
              tipo_midia{
                id
                descricao
                largura
                altura
                formato
              }
              imagem
            }
          }
        }`
      }
    })
  },

  listarAnuncioSemEditorial: () => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
            listarAnuncioSemEditorial{
            id
            titulo
            cor_fundo
            midia{
              id
              type
              video_url
              link_url
              cor_fundo
              tipo_midia{
                id
                descricao
                largura
                altura
                formato
              }
              imagem
            }
          }
        }`
      }
    })
  },

  criarAnuncio: (anuncioInput) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `mutation{
          criarAnuncio(data:{
            titulo: "${(Vue.prototype.$utils.isNotNull(anuncioInput.titulo)) ? anuncioInput.titulo : ''}"
            link: "${(Vue.prototype.$utils.isNotNull(anuncioInput.link)) ? anuncioInput.link : ''}"
            cor_fundo: "${(Vue.prototype.$utils.isNotNull(anuncioInput.cor_fundo)) ? anuncioInput.cor_fundo : ''}"
            ativa: S
            imagem: ${JSON.stringify(anuncioInput.imagem)}
          }){
            id
          }
        }`
      }
    })
  },
  criarAnuncioPrincipal: (anuncioInput) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `mutation{
          criarAnuncioPrincipal(data:{
            titulo: "${(Vue.prototype.$utils.isNotNull(anuncioInput.titulo)) ? anuncioInput.titulo : ''}"
            link: "${(Vue.prototype.$utils.isNotNull(anuncioInput.link)) ? anuncioInput.link : ''}"
            cor_fundo: "${(Vue.prototype.$utils.isNotNull(anuncioInput.cor_fundo)) ? anuncioInput.cor_fundo : ''}"
            ativa: S
            imagem: ${JSON.stringify(anuncioInput.imagem)}
          }){
            id
          }
        }`
      }
    })
  },
  clonarPublicacao: (id, editorial_id, ordem) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `mutation{
          clonarPublicacao(id: ${id}, editorial_id: ${editorial_id}, ordem: ${ordem}){
            id
          }
        }`
      }
    })
  },
  ordenarPublicacao: (editorial_id) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `mutation{
          ordenarPublicacao(editorial_id: ${editorial_id})
        }`
      }
    })
  },
  atualizarOrdemPublicacao: (objectArray) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `mutation{
          atualizarOrdemPublicacao(publicacoes: ${Vue.prototype.$utils.JSONWithoutQuotes(objectArray)})
        }`
      }
    })
  },
}
